<template>
  <div class="column col items-center full-width">
    <SAIPageSpinner v-if="!hydrationComplete" />
    <router-view v-if="hydrationComplete" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { SAIPageSpinner, getEnv } from 'ecx.saigon.ui.common';
import resolveLocalRoute from '@/utils/resolve-local-route';
import getUserPermissions from '@/utils/user-permissions';
import getUserFeatures from '@/utils/user-features';
import UserProfileStepper from '../user-profile-stepper';

export default {
  name: 'HydrationWidget',
  data() {
    return {
      hydrationComplete: false
    };
  },
  computed: {
    ...mapState({
      approvalsLoading: (state) => state.hr.approvalsLoading
    }),
    ...mapGetters('user', [
      'brandName',
      'hasUser',
      'isProfileSetupComplete',
      'userIsAccessLevel',
      'canEditProfile'
    ]),
    ...mapGetters('application', ['hasSettlement', 'creditCheckComplete']),
    ...mapGetters('lease', ['hasLeases']),
    canSeeApprovals() {
      return getUserPermissions()[this.$Constants.PERMISSIONS.HR_APPROVAL];
    }
  },
  watch: {
    canSeeApprovals() {
      if (!this.approvalsLoading && this.canSeeApprovals) {
        this.getHRApprovals();
      }
    }
  },
  methods: {
    ...mapActions('user', ['getUser']),
    ...mapActions('hr', ['getHRApprovals']),
    ...mapActions('application', ['getApplication']),
    ...mapActions('lease', ['getHasLeases', 'getLeases'])
  },
  async beforeMount() {
    // If there is a user profile we will assume hydration is complete
    if (this.hasUser) {
      this.hydrationComplete = true;
      return;
    }

    await this.getUser();

    const hasInLifeFeature = getUserFeatures()[this.$Constants.FEATURES.inLife];
    const hasCreditOnlyRestriction = this.userIsAccessLevel([
      this.$Constants.USER_ACCESS_LEVEL.CREDIT_ONLY
    ]);

    // Prompt the user to finish their profile
    if (!this.isProfileSetupComplete && this.canEditProfile) {
      this.SAIFullScreenDialog({
        parent: this,
        noRouteDismiss: true,
        displayHideAction: false,
        child: UserProfileStepper
      });
    }

    await this.getApplication();

    if (hasCreditOnlyRestriction) {
      hasInLifeFeature ? await this.getLeases() : await this.getHasLeases();
    } else {
      hasInLifeFeature ? this.getLeases() : this.getHasLeases();
    }

    if (
      hasCreditOnlyRestriction &&
      !this.creditCheckComplete &&
      !this.hasLeases
    ) {
      const env = await getEnv();
      return (window.location = resolveLocalRoute(
        env.VUE_APP_CREDIT_CHECK_ROUTE
      ));
    }

    this.hydrationComplete = true;
  },
  components: {
    SAIPageSpinner
  }
};
</script>
